import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderSupplySubContract extends BaseModelAPI {
	static entity = 'workordersupplysubcontract';
	static entityName = 'workordersupplysubcontract';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.materialIssueNumber = '';
			this.purchaseOrderId = '';
			this.purchaseOrder = {};
			this.materialIssueDate = '';
			this.revisi = 0;
			this.wosSubcontStatusId = '';
			this.wosSubcontStatus = {};
			this.vendorId = '';
			this.vendor = {};
			this.remarks = '';
			this.workOrderSupplySubContractDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async generateDetail(this_, data) {
        return this_.$http.post(`${this.entityName}/generatedetail`, data)
        .then(response => {
            return response.data;
        })
        .catch(function(error){
            this_.$store.dispatch('addErrorMessageGlobal', error);
            throw error;
        });
    }

	static async printPdfCustom(this_, id) {
		return this_.$http.post(`${this.entityName}/printpdfcustom/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}
}